const cmtId = 's26';
const BINEOS_PROTO_SUBDOMAIN = 'https://cdn.dl.';
const BINEOS_URI = '/bineosmm/content/Bineos_2_0/bineos.min.js';
const BINEOS_CONTAINER_ID_ARRAY = {
    mm: '74b33b361e',
    ba: 'e2bf8b3d83',
    sz: '4fe11bc449',
    fn: '15997324fd',
}
const DOMAIN_ARRAY = {
    mm: 'mannheimer-morgen.de',
    ba: 'bergstraesser-anzeiger.de',
    sz: 'schwetzinger-zeitung.de',
    fn: 'fnweb.de',
}

const META_DATA_CONTAINER = '.single-data-container__metadata';

let domain = DOMAIN_ARRAY['mm'];
let bineosObj;
let containerId;

export default class Bineos {

    constructor(region) {
        containerId = BINEOS_CONTAINER_ID_ARRAY[region];
        domain = DOMAIN_ARRAY[region];
        this.load();
    }

    async load () {
        let touchpoint = document.querySelector('main').getAttribute('data-touchpoint');
        let postId = document.querySelector('main').getAttribute('data-id');
        let offerCategory = document.querySelector(META_DATA_CONTAINER)?.getAttribute('data-category');
        let offerTitle = document.querySelector(META_DATA_CONTAINER)?.getAttribute('data-title');

        let param = {
            "touchpoint": touchpoint,
            "customTopicId": (typeof offerCategory != 'undefined' ? offerCategory : '') ,
            "productId": parseInt((postId != '' ? postId : '')),
            "productName": (typeof offerTitle != 'undefined' ? offerTitle : '')
        }

        let bineosUrl = BINEOS_PROTO_SUBDOMAIN + domain + BINEOS_URI;
        this.loadDynamicBineosLib(bineosUrl).then( () => {
            bineosObj = new window.Bineos(containerId);
            bineosObj.set(param).send();
        })
    }

    loadDynamicBineosLib(url) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.onload = resolve;
            script.onerror = reject;
            script.src = url;
            script.async = true;
            script.defer = true;
            document.head.append(script);
        });
    }

    getCmtId() {
        return cmtId;
    }

}